import PageBreadcrumbs from "@insite/content-library/Components/PageBreadcrumbs";
import Page from "@insite/mobius/Page";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { ReactNode } from "react";
import { css } from "styled-components";

interface PageLayoutProps {
    showHeader: boolean;
    header: ReactNode;
    showBreadcrumbs: boolean;
    pageContent: ReactNode;
    showFooter: boolean;
    footer: ReactNode;
}

export interface PageLayoutStyles {
    page?: InjectableCss;
}

export const styles: PageLayoutStyles = {
    page: {
        css: css`
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            margin-bottom: 20px;
            margin-top: 12px;
            @media (max-width: 768px) {
                position: static !important;
            }
        `,
    },
};

// This doesn't currently support HMR
const PageLayout = ({ showHeader, header, showBreadcrumbs, pageContent, showFooter, footer }: PageLayoutProps) => {
    return (
        <>
            {showHeader && header}
            {showBreadcrumbs && (
                <Page as="div" {...styles.page}>
                    <PageBreadcrumbs />
                </Page>
            )}
            {pageContent}
            {showFooter && footer}
        </>
    );
};

export default PageLayout;
